import { TranslateService } from '@ngx-translate/core';
import { SharedLanguageService } from '../services/shared-language.service';

export const TranslateOrDefault: (
    translateService: TranslateService | SharedLanguageService,
    query: string,
    defaultValue?: string | undefined,
    params?: Record<string, string | number>
) => string = (
    translateService: TranslateService | SharedLanguageService,
    query: string,
    defaultValue?: string,
    params?: Record<string, string | number>
): string => {
    const translated: string = translateService.instant(query, params);

    if (translated === query) {
        const fallback: string = defaultValue ?? 'Translation not found';
        if (!defaultValue) {
            console.warn(`Failed to translate ${query}`);
        }
        return translateService.instant(fallback, params);
    }

    return translated;
};
